import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormDatePickerProps } from './types';
import { generatePlaceholderForDatePicker } from '../utils';

// components
import { DatePicker } from '@ui';

const FormDatePicker: React.FC<FormDatePickerProps> = ({
  validationRules,
  placeholder: propsPlaceholder,
  renderPlaceholder,
  ...rest
}) => {
  const { t } = useTranslation('form');

  const placeholder = useMemo(() => {
    if (propsPlaceholder) {
      return propsPlaceholder;
    }

    if (renderPlaceholder) {
      return renderPlaceholder(validationRules || []);
    }

    return generatePlaceholderForDatePicker(validationRules || [], t);
  }, [validationRules, propsPlaceholder, renderPlaceholder]);

  return <DatePicker {...rest} placeholder={placeholder} />;
};

export default React.memo(FormDatePicker);
